import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Plane, Plus } from "lucide-react";
import { useDemo } from "@/store/DemoStore";
import { Empty, PageHeader, SearchInput, Segmented, btn } from "@/components/common";
import { TripCard } from "@/components/TripCard";
import { effStatus } from "@/lib/trip";

const ORDER = { BOOKED: 0, QUOTE: 1, COMPLETED: 2 };

export default function TripsPage() {
  const { trips, archivedTrips, client, paidExtra } = useDemo();
  const [params] = useSearchParams();
  const [q, setQ] = useState(params.get("q") || "");
  const [status, setStatus] = useState(params.get("status") || "BOOKED");
  const s = q.toLowerCase();
  const matches = (t) => [t.title, t.destination, t.vessel, t.supplier, t.bookingNumber, t.quoteNumber, client(t.clientId)?.name].join(" ").toLowerCase().includes(s);
  const base = status === "ARCHIVED" ? archivedTrips : trips;
  const list = base
    .filter((t) => (status === "ALL" || status === "ARCHIVED" || effStatus(t) === status) && matches(t))
    .sort((a, b) => ORDER[effStatus(a)] - ORDER[effStatus(b)] || (effStatus(a) === "COMPLETED" ? b.departure.localeCompare(a.departure) : a.departure.localeCompare(b.departure)));
  const count = (st) => (st === "ARCHIVED" ? archivedTrips.length : trips.filter((t) => st === "ALL" || effStatus(t) === st).length);

  return (
    <div>
      <PageHeader title="Trips" subtitle={`${count("BOOKED")} booked · ${count("QUOTE")} quoted · ${count("COMPLETED")} completed`} actions={<Link to="/agent/quotes?new=1" data-testid="trips-new-quote-btn" className={btn.primary}><Plus className="h-4 w-4" />New Quote</Link>} />
      <div className="mb-6 flex flex-col gap-3 md:flex-row md:items-center">
        <SearchInput value={q} onChange={setQ} placeholder="Search client, destination, ship or booking #" testId="trips-search-input" className="md:max-w-md md:flex-1" />
        <Segmented testPrefix="trips-filter" value={status} onChange={setStatus} options={["ALL", "QUOTE", "BOOKED", "COMPLETED", "ARCHIVED"].map((v) => ({ value: v, label: v === "ALL" ? "All" : v[0] + v.slice(1).toLowerCase(), count: count(v) }))} />
      </div>
      <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4" data-testid="trips-grid">
        {list.map((t) => <TripCard key={t.id} trip={t} client={client(t.clientId)} to={`/agent/trips/${t.id}`} paidExtra={paidExtra(t.id)} />)}
      </div>
      {!list.length && <Empty icon={Plane} title={status === "ARCHIVED" ? "No archived trips" : "No trips found"} text={status === "ARCHIVED" ? "Deleted trips move here and can be restored." : "Try another search or status."} />}
    </div>
  );
}
